import { Tooltip } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import Box from "@mui/material/Box"
import { useMemo } from "react";
import { LocalStorage } from "src/framework/commons";
import { ContaUsuario } from "src/store/global.store.types";
import theme from "src/theme/light";

export interface UserInfo {
  name: string;
  email?: string;
  image?: string;
  icon?: string | null;
}

export interface UserClassificacaoInfoProps {
  contaUsuario?: ContaUsuario | null;
  userInfo: UserInfo
}

const useStyles = makeStyles({
  classificacaoText: {
    fontSize: 13,
    color: theme.palette.text.secondary
  },
  usernameText: {
    fontSize: 13,
    textTransform: "uppercase",
    color: theme.palette.text.secondary
  }
})

const UserClassificacaoInfo = ({ userInfo, contaUsuario }: UserClassificacaoInfoProps) => {
  const classes = useStyles()
  const _upload = LocalStorage.get("solar.uploads", true);
  
  const uploadUrl = useMemo(()=>{
    return _upload?.data?.url
  },[_upload])
  
  if (!uploadUrl || !contaUsuario || !userInfo ) {
    return <div />
  }
  
  return (
    <Box flex={1} display="flex" alignItems="center" justifyContent={"flex-end"}>
      {contaUsuario.conta?.classificacao?.url && contaUsuario.conta?.classificacao?.nome&& (
        <Tooltip title={contaUsuario.conta.classificacao.nome || ""}>
          <img alt="classificacao-conta" width="42px" src={`https://${uploadUrl}${contaUsuario.conta.classificacao.url}`} />
        </Tooltip>
      )}
      <Box marginLeft={1} display="flex" flexDirection={"column"} alignItems="flex-end" justifyContent={"center"}>
        <span className={classes.usernameText}>
          <strong>{userInfo.name}</strong>
        </span>
        {contaUsuario.conta?.grupos_acesso?.nome && (
          <span className={classes.classificacaoText}>
            {contaUsuario.conta.grupos_acesso.nome}
          </span>
        )}
      </Box>
    </Box>
  )
}

export { UserClassificacaoInfo }